import React from 'react';
import { Box, FormControl, FormLabel, Input, Select, Textarea } from '@chakra-ui/react';
import { observer } from 'mobx-react';

const QrOptionalFields = observer(({ store }) => {
  const type = store.qrType;
  if (!type) return null;

  if (type.id === 'crypto') {
    return (
      <Box mt={3} p={3} borderRadius="lg" bg="blackAlpha.50" _dark={{ bg: 'whiteAlpha.50' }}>
        <FormControl mb={2} size="sm">
          <FormLabel fontSize="xs">Currency</FormLabel>
          <Select
            value={store.formData.currency ?? 'BTC'}
            onChange={(e) => store.setFormData('currency', e.target.value)}
            size="sm"
            borderRadius="lg"
          >
            <option value="BTC">Bitcoin</option>
            <option value="ETH">Ethereum</option>
            <option value="SOL">Solana</option>
            <option value="Custom">Custom</option>
          </Select>
        </FormControl>
        <FormControl mb={2} size="sm">
          <FormLabel fontSize="xs">Amount (optional)</FormLabel>
          <Input
            value={store.formData.amount ?? ''}
            onChange={(e) => store.setFormData('amount', e.target.value)}
            placeholder="0.001"
            size="sm"
            borderRadius="lg"
          />
        </FormControl>
        <FormControl size="sm">
          <FormLabel fontSize="xs">Message (optional)</FormLabel>
          <Input
            value={store.formData.message ?? ''}
            onChange={(e) => store.setFormData('message', e.target.value)}
            placeholder="Payment for..."
            size="sm"
            borderRadius="lg"
          />
        </FormControl>
      </Box>
    );
  }

  if (type.id === 'email') {
    return (
      <Box mt={3} p={3} borderRadius="lg" bg="blackAlpha.50" _dark={{ bg: 'whiteAlpha.50' }}>
        <FormControl mb={2} size="sm">
          <FormLabel fontSize="xs">Subject (optional)</FormLabel>
          <Input
            value={store.formData.subject ?? ''}
            onChange={(e) => store.setFormData('subject', e.target.value)}
            placeholder="Email subject"
            size="sm"
            borderRadius="lg"
          />
        </FormControl>
        <FormControl size="sm">
          <FormLabel fontSize="xs">Body (optional)</FormLabel>
          <Textarea
            value={store.formData.body ?? ''}
            onChange={(e) => store.setFormData('body', e.target.value)}
            placeholder="Email body..."
            size="sm"
            borderRadius="lg"
            rows={2}
          />
        </FormControl>
      </Box>
    );
  }

  if (type.id === 'sms') {
    return (
      <Box mt={3} p={3} borderRadius="lg" bg="blackAlpha.50" _dark={{ bg: 'whiteAlpha.50' }}>
        <FormControl size="sm">
          <FormLabel fontSize="xs">Pre-filled message (optional)</FormLabel>
          <Textarea
            value={store.formData.message ?? ''}
            onChange={(e) => store.setFormData('message', e.target.value)}
            placeholder="Pre-filled SMS text"
            size="sm"
            borderRadius="lg"
            rows={2}
          />
        </FormControl>
      </Box>
    );
  }

  return null;
});

export default QrOptionalFields;
